import dayjs from 'dayjs';
import React, { useState } from 'react';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../../utils/Button';
import InputField, {
    InputDateField,
    SelectOption,
    TextareaField,
    addOption
} from '../../../../utils/InputField';
import { handleEditSubscriptionsFeaturesOpe } from '../SubscriptionsDetailsOpe';

const SelectAr = [
    { key: 'active', title: 'Active' },
    { key: 'deleted', title: 'Deleted' }
];

function EditSubscriptionsFeatureModal({ data, handleReload, closeModal }) {
    const { setMessage } = useTemplate();
    const { id, featureName, featureDescription, timeDeployed, status } = data;
    const [loading, setLoading] = useState(false);
    // -- Set formData in state
    const [formData, setFormData] = useState({
        ApplicationId: id || '',
        FeatureName: featureName || '',
        FeatureDescription: featureDescription || '',
        DateDeployed: dayjs(timeDeployed * 1000).format('YYYY-MM-DD') || '',
        Status: status || ''
    });

    // -- Set value to formData
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name) {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    const handleOnSubmit = (e) => {
        setLoading(true);
        e.preventDefault();
        handleEditSubscriptionsFeaturesOpe(id, formData)
            .then(({ title }) => {
                setLoading(false);
                setMessage({ type: 'success', text: title });
                handleReload();
                closeModal();
            })
            .catch((err) => {
                setLoading(false);
                setMessage({ type: 'error', text: err.toString(0) });
            });
    };
    return (
        <form onSubmit={handleOnSubmit} className="flex flex-col items-center justify-center gap-3">
            <InputField
                label="Feature Name"
                name="FeatureName"
                formData={formData}
                onChange={handleChange}
            />
            <TextareaField
                label="Feature Description"
                name="FeatureDescription"
                formData={formData}
                onChange={handleChange}
            />
            <InputDateField
                title="Deployment Date"
                name="DateDeployed"
                formData={formData}
                onChange={handleChange}
            />
            <SelectOption
                title="Status"
                name="Status"
                formData={formData}
                onChange={handleChange}
                options={SelectAr?.map((item) => addOption(item.key, item.title, item.key))}
            />

            <div className="w-full flex flex-row gap-2 justify-end items-center">
                <ButtonCancel title="Cancel" onClick={closeModal} />
                <ButtonPrimary title="Save" btnType="submit" loading={loading} />
            </div>
        </form>
    );
}

export default EditSubscriptionsFeatureModal;
